// Styles load from `vite_stylesheet_tag 'shared'` in the layout so first
// paint isn't unstyled. Do not import shared.css here.
import { renderLatexIn } from '../lib/latex'
import { initVideoPlayers } from '../lib/video-player'

function boot() {
  if (document.querySelector('[data-has-latex]')) renderLatexIn(document)
  initVideoPlayers()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
